import React, { useState } from 'react'
import TextFieldUniversal from '../../../validate/form/text/TextFieldUniversal'

const CommentTextField = ({ required, setValidate, setValueForm, forciblyValue, onBlurMy }) => {

	const [value, setValue] = useState('')

	// console.log('forciblyValue !!!', forciblyValue)

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Коментар'} 
        placeholder={'Введіть коментар'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
        onBlurMy={onBlurMy}
		multiline
		rows={4}
    />
  )
}

export default CommentTextField